import 'dom4';

import PhaenoPage from './modules/PhaenoPage';

const phaenoPage = new PhaenoPage();
phaenoPage.init();
